import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCButton, SCLoader } from 'rollup-allspark';
import ComponentPlaceholder from '../../../components/ComponentPlaceholder';
import { EXPORT_TYPE } from '../../../config/constants/analytics';
import { isEmpty, printf } from '../../../utils';
import { getEntity } from '../actions';
import { GET_SIGNED_PREV_REPORT } from '../sagaMap';
import { makeSelectProperty } from '../selectors';

const PreviousReports = ({
  files,
  getSignedReportUrl,
  isLoadingPrevReports,
}) => {
  if (isLoadingPrevReports) {
    return (
      <div className="flex h-32 items-center justify-center">
        <SCLoader diameter={50} lineWidth={5} />
      </div>
    );
  }

  if (isEmpty(files)) {
    return <ComponentPlaceholder label="No reports found" />;
  }

  const onDownloadBtnClick = (file, dlType = EXPORT_TYPE.CSV) => {
    getSignedReportUrl({
      url: printf(GET_SIGNED_PREV_REPORT.url, file.path, dlType),
      callbackFn: respUrl => {
        if (!isEmpty(respUrl)) {
          window.open(respUrl, '_blank');
        }
      },
    });
  };

  const sortedFiles = [...files].sort((a, b) =>
    (b?.name || '').localeCompare(a?.name || ''),
  );

  return (
    <div className="h-full overflow-y-auto">
      <table className="table w-full divide-y divide-grey border-b border-grey">
        <thead>
          <tr>
            <th className="h-10 bg-grey-lighter text-left pl-4">Report</th>
            <th className="h-10 bg-grey-lighter">Files</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-grey">
          {sortedFiles.map((f, index) => (
            <tr key={`report-index-${index + 1}`} className="h-10">
              <td>
                <div className="flex items-center pl-4">{f.name}</div>
              </td>
              <td>
                <div className="flex justify-center gap-x-2">
                  <SCButton
                    variant="secondary"
                    size="sm"
                    className="px-2 w-auto bg-grey-lighter text-black rounded-lg flex items-center font-medium gap-x-1 hover:bg-grey"
                    action={() => onDownloadBtnClick(f, EXPORT_TYPE.XLSX)}
                  >
                    <i className="kt-download text-xs" />
                    XLSX
                  </SCButton>
                  <SCButton
                    variant="secondary"
                    size="sm"
                    className="px-2 w-auto bg-grey-lighter text-black rounded-lg flex items-center font-medium gap-x-1 hover:bg-grey"
                    action={() => onDownloadBtnClick(f, EXPORT_TYPE.CSV)}
                  >
                    <i className="kt-download text-xs" />
                    CSV
                  </SCButton>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

PreviousReports.propTypes = {
  files: PropTypes.array,
  getSignedReportUrl: PropTypes.func,
  isLoadingPrevReports: PropTypes.number,
};

const mapStateToProps = createStructuredSelector({
  files: makeSelectProperty('previousOrderReports'),
  isLoadingPrevReports: makeSelectProperty('isLoadingPrevReports'),
});

const mapDispatchToProps = dispatch => ({
  getSignedReportUrl: params => dispatch(getEntity(params)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(PreviousReports);
